export const UtilityColors = {
    gas: "rgba(249, 93, 106, 1)",
    electricity: "rgba(255, 166, 0, 1)",
    water: "rgba(47, 75, 124, 1)"
};

export const ChartColors = {
    a: 'rgba(0, 63, 92, 1)',
    b: 'rgba(47, 75, 124, 1)',
    c: 'rgba(102, 81, 145,1)',
    d: 'rgba(160, 81, 149, 1)',
    e: 'rgba(212, 80, 135, 1)',
    f: 'rgba(249, 93, 106, 1)',
    g: 'rgba(255, 124, 67, 1)',
    h: 'rgba(255, 166, 0, 1)',
    i: 'rgb(104,169,194)',
    j: 'rgb(209,56,41)',
    k: 'rgb(226,201,88)',
    l: 'rgb(52,180,154)'
};